
const buttonsTypes = ["primary", "secondary", "ternary"];
const buttonsSizes = ["large", "small"];

export default {
  props: {
    disabled : {
      type: Boolean,
      required: false,
      default : false
    },
    content: {
      type: String,
      required: true,
      default: "",
    },
    type: {
      type: String,
      required: true,
      default: "primary",
      validator: (value: string) => {
        return buttonsTypes.indexOf(value) !== -1;
      },
    },
    size: {
      type: String,
      required: true,
      default: "large",
      validator: (value: string) => {
        return buttonsSizes.indexOf(value) !== -1;
      },
    },
  },
  data() {
    return {
      //
    };
  },
  mounted(){
    this.disabled && (this.disabledEffect());
  },
  methods: {
    disabledEffect(){
      this.$refs.btn.classList.remove("opacity-80", "hover:opacity-100");
      this.$refs.btn.classList.add(`opacity-50`);
    },
  }
};
